<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        {{ title }}
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "main-page",
  
  data() {
    return {
      title: '혼디도랑 개발팀 메인 페이지',
    }
  },
  components: {
  },
  computed:{
  },

  mounted(){
  },

};
</script>

<style>

</style>